import { render, staticRenderFns } from "./GoodsIsBo.vue?vue&type=template&id=1e895a39&scoped=true"
import script from "./GoodsIsBo.vue?vue&type=script&lang=js"
export * from "./GoodsIsBo.vue?vue&type=script&lang=js"
import style0 from "./GoodsIsBo.vue?vue&type=style&index=0&id=1e895a39&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e895a39",
  null
  
)

export default component.exports